import type { ArcadePalette } from "@/utils/arcade/theme";
import type { Fx } from "./fx";

export const LEVEL_SECONDS = 30;
export const FEVER_COMBO = 25;
export const FEVER_SECONDS = 8;

// Levels and fever, shared by the games. A level lasts LEVEL_SECONDS and each
// game reads `level` to switch on new hazards. Every FEVER_COMBO streak sets off
// a fever that doubles points for a few seconds.
export function createProgression(fx: Fx, palette: ArcadePalette, labels: string[]) {
  let level = 1;
  let fever = 0;
  let lastFeverCombo = 0;
  return {
    get level() {
      return level;
    },
    get fever() {
      return fever > 0;
    },
    get feverLeft() {
      return fever;
    },
    get multiplier() {
      return fever > 0 ? 2 : 1;
    },
    update(dt: number, time: number, combo: number) {
      const next = 1 + Math.floor(time / LEVEL_SECONDS);
      if (next > level) {
        level = next;
        fx.banner(`LEVEL ${level}`, labels[level - 2] ?? "Faster and busier", palette.primary);
      }
      fever = Math.max(0, fever - dt);
      if (combo < lastFeverCombo) lastFeverCombo = 0;
      if (combo > 0 && combo % FEVER_COMBO === 0 && combo !== lastFeverCombo) {
        lastFeverCombo = combo;
        fever = FEVER_SECONDS;
        fx.banner("FEVER", "Double points", palette.accent);
      }
    },
  };
}
